import { getMessaging, getToken, onMessage } from "firebase/messaging";
import app from "../firebase";
import { ref, update } from "firebase/database";
import { db } from "../firebase";

const VAPID_KEY = "BEuwdrJSPqwaot2b3HvrulNz3vHmoQJ9RaSOKmsKgHB4DcEZe20wvZLSHzrIwpXya1gJPlFHG1IAgHWmMdW1TSM";

let messaging = null;
function getMsg() {
  if (!messaging) {
    try { messaging = getMessaging(app); } catch (e) { return null; }
  }
  return messaging;
}

// Request permission + get token + save to DB
export async function initNotifications(uid) {
  if (!("Notification" in window) || !("serviceWorker" in navigator)) return;
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;
    const msg = getMsg();
    if (!msg) return;
    const token = await getToken(msg, { vapidKey: VAPID_KEY });
    if (token && uid) {
      await update(ref(db, `users/${uid}`), { fcmToken: token });
    }
  } catch (e) {
    // Silently fail — notifications are optional
  }
}

// Foreground message handler (app is open)
export function onForegroundMessage(callback) {
  const msg = getMsg();
  if (!msg) return () => {};
  try {
    return onMessage(msg, callback);
  } catch (e) {
    return () => {};
  }
}

// Send notification via Vercel API (fire-and-forget)
export function sendPushNotification({ token, title, body, url }) {
  if (!token) return;
  fetch("/api/notify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, title, body, url }),
  }).catch(() => {}); // silent — don't block chat
}
